(function() {
  'use strict';
  angular.module('benefits')
    .component('dhmoBenefitInfo', {
      bindings: {
        refId: '='
      },
      controller: ['benefitService', '$window', '$state', function dhmoBenefitInfoController(benefitService, $window, $state) {
        var self = this;

        function findCategoryEntries(schedule, categoryCode) {
          if (!schedule || !categoryCode) {
            return [];
          }
          var category = _.find(schedule.categories, function(item) {
            return item && item.code === categoryCode;
          });
          return category && Array.isArray(category.procedures) ? category.procedures : [];
        }

        function findCategoryEligibility(schedule, categoryCode) {
          if (!schedule || !categoryCode) {
            return null;
          }
          var category = _.find(schedule.categories, function(item) {
            return item && item.code === categoryCode;
          });
          return category && category.eligibility ? category.eligibility : null;
        }

        self.openLimitationsAndExclusions = function(event) {
          if (event) {
            event.preventDefault();
          }
          $window.open($state.href('limitationsAndExclusions'), '_blank');
        };
        self.$onInit = function() {
          self.running = true;
          self.serviceUnavailable = false;
          self.allOpen = false;
          benefitService.planSummaryPromise.then(function(data) {
            self.planSummary = data;
          });
          self.categories = [
            {name: 'Miscellaneous', code: 'AGS', open: false, entries: [], eligibility: null},
            {name: 'Diagnostic', code: 'DIA', open: false, entries: [], eligibility: null},
            {name: 'Endodontics', code: 'END', open: false, entries: [], eligibility: null},
            {name: 'Oral Surgery', code: 'OMS', open: false, entries: [], eligibility: null},
            {name: 'Orthodontics', code: 'ORT', open: false, entries: [], eligibility: null},
            {name: 'Periodontics', code: 'PER', open: false, entries: [], eligibility: null},
            {name: 'Preventive', code: 'PRV', open: false, entries: [], eligibility: null},
            {name: 'Fixed Prosthetic', code: 'PSF', open: false, entries: [], eligibility: null},
            {name: 'Removable Prosthetic', code: 'PSR', open: false, entries: [], eligibility: null},
            {name: 'Restorative', code: 'RST', open: false, entries: [], eligibility: null}
          ];
          self.toggleOpen = function() {
            self.allOpen = !self.allOpen;
            _.each(self.categories, function(category) {
              category.open = self.allOpen;
            });
          };
          if (!benefitService.copaySchedulePromise) {
            self.running = false;
            return;
          }
          benefitService.copaySchedulePromise.then(function(data) {
            self.copaySchedule = data;
            _.each(self.categories, function(category) {
              category.entries = findCategoryEntries(data, category.code);
              category.eligibility = findCategoryEligibility(data, category.code);
            });
            self.serviceUnavailable = !!(data && data.serviceUnavailable);
            self.running = false;
          }, function() {
            self.serviceUnavailable = true;
            self.running = false;
          });
        };
      }],
      templateUrl: '/js/benefits/dhmoBenefitInfo.html' + appVersion
    });
})();
